module.exports = __webpack_public_path__ + "img/club.db5a0585.png";